import { Button, Card, Col, Layout, Row, notification } from 'tea-component';
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from "umi";
import AnalysisCalculateHint from './components/analysis_calculate_hint';
import { namespace } from './model';
import { NoticeBuilder } from './NoticeBuilder';
import {checkNullString, getLocalText, useDblIntl} from '../../../utils/utils';
import AnalysisLineChart from './components/AnalysisLineChart';
import AnalysisCondition from './components/analysis_condition';
import AnalysisCalculate from './components/analysis_calculate';
import FilterBasicCondition from './components/filter_basic_condition';
// import DataTable from '../../Multidimensional/Analysis/components/GuideOperation/DataTable';
import { CustomPrompt } from "@/pages/datalab/components/CustomPrompt";
import { useNoTableData } from '@/pages/datalab/pages/Multidimensional/Analysis/components/GuideOperation/useNoTableData';
import NoData from '@/pages/datalab/pages/Multidimensional/Analysis/components/GuideOperation/NoData';
import { buriedPoint } from "@/pages/home/utils/buriedPoint";
import './index.scss';

const { Content } = Layout;

export default connect((state: any) => {
  const {
    columnFilters = [],
    filterBasic = [],
    columnSensitive = [],
    columnMetrics,
    columnDimensions,
    filterLogic = 0,
    hashEqual = true,
    hadAnalysed = false,
    table = {},
    saveObj,
    task_id,
    hashEqualForSave,
  } = state[namespace];
  
  return {
    columnFilters,
    filterBasic,
    columnSensitive,
    columnMetrics,
    columnDimensions,
    filterLogic,
    hashEqual,
    hadAnalysed,
    table,
    saveObj,
    task_id,
    hashEqualForSave,
    exploreGame: state.exploreAnalysisGames.exploreGame,
    gameCode: state.datalab.gameCode,
  };
})(ExplorationAnalysis);

function ExplorationAnalysis(props: any) {
  const { columnFilters, filterBasic, columnSensitive, columnMetrics, columnDimensions, filterLogic, hashEqual, hashEqualForSave, exploreGame, gameCode} =
    props;
  
  const { dblFormatMessage: explorationFormatMessage, createDblFormatMessage, commonFormatMessage, isEn } = useDblIntl("exploration");
  const dblFormatMessageTitle = createDblFormatMessage("multi");
  
  const forceGameCode = props?.location?.query?.gameCode;
  const taskId = props?.location?.query?.taskId;
  const [curGameCode, setCurGameCode] = useState('');
  const [curTaskId, setCurTaskId] = useState<string | undefined>(undefined);
  const [showSaveModel, setShowSaveModel] = useState(false);
  
  const conditionNotice = useMemo(() => {
    let noticeString = '';
    noticeString = `${noticeString}${NoticeBuilder.buildMetrics(columnMetrics, isEn)}`;
    noticeString = `${noticeString}${NoticeBuilder.buildFilter(filterBasic, columnFilters, filterLogic, props, isEn)}`;
    noticeString = `${noticeString}${NoticeBuilder.buildDimensions(columnDimensions, filterBasic, isEn)}`;
    return noticeString;
  }, [
    JSON.stringify(columnFilters),
    JSON.stringify(columnSensitive),
    JSON.stringify(filterBasic),
    JSON.stringify(columnMetrics),
    JSON.stringify(columnDimensions),
    filterLogic,
    isEn,
  ]);
  
  const noData = useNoTableData(props);
  const disableButton = !columnMetrics || columnMetrics.length === 0;
  const isEdit = props?.location?.query?.from === 'edit' || false;
  const pageTitle = useMemo(() => {
    const from = props?.location?.query?.from || '';
    if (from === 'edit' || from === 'view') {
      const editMsg = props?.location?.query?.editMsg ? JSON.parse(props?.location?.query?.editMsg) : props?.location?.query;
      return getLocalText(isEn, editMsg?.nameCn, editMsg?.name);
    }
    if (from === 'add') {
      return dblFormatMessageTitle("unnamed_chart_title");
    }
    return explorationFormatMessage("title");
  }, [isEn]);
  
  const editMsg = props?.location?.query || {};
  useEffect(() => {
    buriedPoint({
      pageId: isEdit ? '600602' : '600601',
      pageName: isEdit ? editMsg.name: '探索分析',
      extInfo: isEdit ? `{"pageName": "${editMsg.name}", "pageNameCn": "", "id": "${taskId}"}` : `{"pageName": "Exploration Analysis", "pageNameCn": "探索分析", "id": ""}`,
      pagePath: '/Action/ExploreAnalysis',
      uid: gameCode,
      typeId: "datalab_pc_v2",
      menuId: '0',
    });
  }, [gameCode]);
  
  useEffect(() => {
    if (!checkNullString(forceGameCode)) {
      props.dispatch({ type: 'datalab/changeGame', payload: { gameCode: forceGameCode } });
    }
  }, [forceGameCode]);
  
  useEffect(() => {
    props.dispatch({
      type: `${namespace}/resetState`,
      payload: {
        gameCode,
      },
    });
    props.dispatch({
      type: `${namespace}/initField`,
      payload: {
        gameCode,
        exploreGame,
      },
      callback: () => {
        props.dispatch({
          type: `${namespace}/initPackageField`,
          payload: {
            gameCode,
          },
          callback: () => {
            if (taskId) {
              props.dispatch({
                type: `${namespace}/getTaskDetail`,
                payload: {
                  gameCode,
                  taskId,
                },
                callback: () => {
                  calculate();
                },
              });
            } else {
              calculate();
            }
          },
        });
        props.dispatch({
          type: `${namespace}/getCountrySelector`,
          payload: {
            gameCode,
            selectorList: ['country', 'area']
          }
        });
      },
    });
  }, [gameCode, exploreGame]);
  
  const calculate = () => {
    props.dispatch({
      type: `${namespace}/getDataAnlysis`,
      payload: {},
      callback: (payload: {errorMsg: string;}) => {
        if (payload?.errorMsg) {
          notification.error({
            className: 'dbl-analysis-msg',
            description: payload.errorMsg,
            duration: 3000
          });
        }
        props.dispatch({
          type: `${namespace}/save`,
          payload: { ...(payload || {}), analysisRunning: false, analysisReqId: '' },
        });
      },
    });
  };
  
  // 切换游戏时，清除数据
  useEffect(() => {
    if (curGameCode === null) {
      setCurGameCode(gameCode);
      return;
    }
    if (curGameCode !== gameCode || curTaskId !== taskId) {
      props.dispatch({
        type: `${namespace}/resetState`,
        payload: {
          gameCode,
        },
      });
      setCurTaskId(taskId);
      setCurGameCode(gameCode);
    }
  }, [gameCode, taskId]);
  
  // const handleOnResize = ({ domElement }) => {
  //   // setTableWidth(domElement.offsetWidth);
  //   //  触发window resize事件，重新渲染表格和曲线图
  //   setTimeout(() => {
  //     fireWindowResize();
  //   }, 10);
  // };
  
  // const onSubmit = (pathname: string) => {
  //   props.dispatch({
  //     type: `${namespace}/saveCondition`,
  //     payload: {
  //       game_code: gameCode,
  //       taskId: task_id,
  //       ...saveObj,
  //     },
  //     callback: (param: any, resp: any) => {
  //       if (resp.code === 0) {
  //         const id =
  //           !checkNullString(task_id) && !param.task_id
  //             ? 'save_as_success'
  //             : 'save_success';
  //         notification.success({
  //           description: dblFormatMessageTitle(id, { name: param.name }),
  //         });
  //         setShowSaveModel(false);
  //       } else {
  //         notification.error({
  //           description: dblFormatMessageTitle('save_error', { name: param.name }),
  //         });
  //       }
  //       history.push(pathname);
  //     },
  //   });
  // };
  //
  // const onCancle = (pathname: string) => {
  //   history.push(pathname);
  // };
  
  return (
    <Content>
      <Content.Header
        className='dbl-header'
        title={pageTitle}
        operation={
          <Button type="primary" className="item-btn" disabled={disableButton} onClick={() => setShowSaveModel(true)}>
            {commonFormatMessage("save")}
          </Button>
        }
      />
      <Content.Body full className="exploration-analyze dtb-dl-container multi-analysis explore-analysis">
        <Row>
          <Col>
            <Card>
              <Card.Body style={{ padding: '6px 20px' }}>
                <div className="exploration-analyze-text dtb-condition-notice">
                  <div className="content" dangerouslySetInnerHTML={{ __html: conditionNotice }}></div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row gap={24} className="margin-t-10" style={{ flex: '1 1', overflow: 'hidden' }}>
          <Col span={12} style={{ height: '100%' }}>
            <div className="left-context" style={{ height: '100%' }}>
              <AnalysisCondition />
              <AnalysisCalculate showSaveModel={showSaveModel} setShowSaveModel={setShowSaveModel} />
            </div>
          </Col>
          <Col span={12} style={{ height: '100%' }}>
            <AnalysisCalculateHint />
            <div className={`right-context ${!hashEqual ? 'right-context-height' : ''}`}>
              <Card>
                <Card.Body className={`table-analysis ${noData ? '' : 'table-exploration-analyze'}`}>
                  <FilterBasicCondition />
                  {noData ? (
                    <NoData />
                  ) : (
                    <>
                      {' '}
                      <AnalysisLineChart key={hashEqual} namespace={namespace} filtersArr={filterBasic} />
                    </>
                  )}
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </Content.Body>
      <CustomPrompt
        title={explorationFormatMessage("leave_info")}
        message={commonFormatMessage("leave_message", {name: ''})}
        isPrompt={!hashEqualForSave && (columnMetrics?.length !== 0)}
        // onConfirm={isEdit ? onSubmit : undefined}
        // confirmBtn={isEdit ? commonFormatMessage('save') : undefined}
        // cancelBtn={isEdit ? commonFormatMessage('leave') : undefined}
        // onCancle={isEdit ? onCancle : undefined}
      />
    </Content>
  );
}
